import React from 'react';
import {
    StyledLinearProgress,
    Numbers,
    Percent
} from '../../../Dashboard/Progress/Progress.styles';
import { CampaignStatus } from '../../../components/CampaignStatus';
import { createDate } from '../../../utilities';
import {
    InformationTitle,
    InformationDescription,
    InformationWrapper,
    InformationName
} from '../../CampaignDetails.styles';
import { OverviewProps } from './Overview.interface';
import { GridWrapper, Wrapper } from './Overview.styles';

export function Overview({ status, startDate, endDate, dovepoints, scheduledEndDate }: OverviewProps) {
    return (
        <div>
            <InformationTitle>Overview</InformationTitle>
            <InformationWrapper>
                <InformationName>Status</InformationName>
                <CampaignStatus status={status}/>
                <GridWrapper>
                    <div>
                        <InformationName>Start Date</InformationName>
                        <InformationDescription>{createDate(startDate)}</InformationDescription>
                    </div>
                    <div>
                        <InformationName>End Date</InformationName>
                        <InformationDescription>{endDate ? createDate(endDate) : '-'}</InformationDescription>
                    </div>
                    <div>
                        <InformationName>DovePoints Used</InformationName>
                        {dovepoints.dovePointsLimit ?
                            <Wrapper>
                                <div>
                                    <StyledLinearProgress 
                                        variant="determinate" 
                                        value={dovepoints.usedDovePoints >= dovepoints.dovePointsLimit ? 100 : Math.floor(dovepoints.usedDovePoints*100/dovepoints.dovePointsLimit)}
                                    />
                                    <Numbers>{dovepoints.usedDovePoints}/{dovepoints.dovePointsLimit}</Numbers>
                                </div>
                                <Percent>{Math.floor(dovepoints.usedDovePoints*100/dovepoints.dovePointsLimit)}%</Percent>
                            </Wrapper>
                            :
                                <>
                                    <InformationDescription>{dovepoints.usedDovePoints}</InformationDescription>
                                </>
                        }
                    </div>
                    <div>
                        <InformationName>Scheduled End Date</InformationName>
                        <InformationDescription>{scheduledEndDate ? createDate(scheduledEndDate) : '-'}</InformationDescription>
                    </div>
                </GridWrapper>
            </InformationWrapper>
        </div>
    )
}
